module.exports = __webpack_public_path__ + "static/img/preview.f427d041.png";